import Header from "../../../../Components/Header/Header";
import Sidebar from "../../../../Components/Sidebar/Sidebar";
import Select from 'react-select'
import React, { useEffect, useReducer, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../Helper/Context";
import { GardenMasterTableDataAPI } from "../../../../Redux/MasterSlice/GardenMasterSlice";
import { useSearchParams } from "react-router-dom";
import ViewURL from "../../../../Components/ViewURL/ViewURL";
import GardenPopup from "../GardenPopup/GardenPopup";
import DeletePopup from "../GardenPopup/DeletePopup";
import { Pegination } from "../../../../Components/Pegination/Pegination";
import { WardNameDataDDL } from "../../../../Components/CommonDDL/WardNameDataDDL";
import { SectorDataDDL } from "../../../../Components/CommonDDL/SectorDataDDL";
import GardenWisemaintenanceStatusPopUp from "./GardenWisemaintenanceStatusPopUp";


export default function GardenWisemaintenanceStatus() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [GardenMasterPopupShow, setGardenMasterPopupShow] = useState('')
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [rowNo, setrowNo] = useState(1)


    const handleAddOnClick = () => {
        setGardenMasterPopupShow(true)
    }
    const handleOnCloseClick = () => {
        setGardenMasterPopupShow(false)
    }

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [SectorName, setSectorName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setSectorName({
            ...SectorName,
            ID: 0,
            Label: 'Select...',
        })

        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    useEffect(() => {
        const data = {
            M_AssetID: 0,
            UserID: UserID,
            token: token,
            From: From,
            To: To,
            M_AssetTypeID: '1',
            M_WardID: WardName.ID,
            M_GD_SectorID: SectorName.ID,
        }
        dispatch(GardenMasterTableDataAPI({ data }))
    }, [IsPost, To, IsClear, isSearch])

    const { tableData, isloading } = useSelector(state => state.GardenMasterTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [WardName.ID, SectorName.ID])

    return (
        <div>
            <Header
                // DashboardHeading="Garden Maintainance"
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar
                    ProjectTypeId={ProjectTypeId} active='gardenwisemaintenancestatus' listActive="gardenMaster" />
                <div className="content">
                    <div className="page-header ">
                        <div className="page-block ">
                            <div className="row align-items-center ">
                                <div className="col-md-12">
                                    {/* <div className="page-header-title">
                                        <h5 className="ps-2">Master */}
                                    {/* <span className="float-end fs-6">
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: SelectWard.ID, label: SelectWard.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setSelectWard({ ...SelectWard, ID: e.value, Label: e.label })
                                                            :
                                                            setSelectWard({ ...SelectWard, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={SelectWard.DDL}
                                                />
                                            </span> */}
                                    {/* </h5>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-4 master_border px-2">
                        <div>
                            <h5 className="ps-1 py-3 ">Garden Wise Maintainance Status</h5>
                            {/* <div className="float-end butt">
                                <GardenPopup
                                    open={GardenMasterPopupShow}
                                    GardenMasterFlag='GardenMaster'
                                    popupHeading="Garden Master"
                                    M_AssetTypeID='1'
                                    handleIsPost={handleIsPost}
                                // handleCloseOnClick={handleCloseOnClick}
                                />
                            </div> */}
                        </div>
                        <div className="row m-0 ">
                            <div className="col-12 py-1  rounded rounded-2 shadow"
                                style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                <div className="col-12  ">
                                    <div className="row py-1 rounded2">
                                        <div className="col-12 col-md-4 col-lg-3">
                                            <WardNameDataDDL
                                                WardName={WardName}
                                                setWardName={setWardName}
                                            />
                                        </div>
                                        <div className="col-12 col-md-4 col-lg-3">
                                            <SectorDataDDL
                                                SectorName={SectorName}
                                                setSectorName={setSectorName}
                                                WardName={WardName}
                                            />
                                        </div>
                                        <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                            <button type="button"
                                                className="btn-clear btn btn-primary mx-2"
                                                onClick={handleSearch}
                                            >
                                                Search</button>
                                            <button type="button"
                                                className="btn btn-outline-danger"
                                                onClick={handleClear}
                                            >
                                                Clear</button>
                                        </div>
                                    </div>
                                    <div className="row mob_table table-responsive pt-1">
                                        <table id="totalordergenerated"
                                            cellPadding="0"
                                            cellSpacing="0"
                                            border="0"
                                            className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className="sr_no_col">Sr No.</th>
                                                    <th>Ward Name</th>
                                                    <th>Sector Name</th>
                                                    <th>Area Name</th>
                                                    <th>Garden Name</th>
                                                    <th>Image</th>
                                                    <th>Status</th>
                                                    <th>Action</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                        <tr style={{ width: '100%' }}>
                                                            <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                            <td>{item.wardName ? item.wardName : '-'}</td>
                                                            <td>{item.sectorName ? item.sectorName : '-'}</td>
                                                            <td>{item.areaName ? item.areaName : '-'}</td>
                                                            <td>{item.assetName ? item.assetName : '-'}</td>

                                                            <td style={{ textAlign: "center" }}>
                                                                {
                                                                    (item.assetPhoto == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <>
                                                                            <i className="fa-regular fa-images"
                                                                                style={{ cursor: 'pointer', alignItems: "center" }} title='View'
                                                                                onClick={() => handleShowImage(item.assetPhoto)}
                                                                            ></i>
                                                                        </>
                                                                }
                                                            </td>
                                                            {/* <td style={{ textAlign: "center" }}>{ <i style={{ cursor: 'pointer', fontSize: '1rem' }} className="fa-solid fa-location-dot"></i>}</td> */}
                                                            <td className="text-nowrap">
                                                                <span className={`${item.statusName === "Active" ? "badge-style" : "badge-style--orange "}`}
                                                                                 style={{  width: "80px",}}>
                                                                                {item.statusName ? item.statusName : '-'}
                                                                </span>
                                                               </td>
                                                            <td style={{ textAlign: "center", width: '7%' }}>
                                                                <span>
                                                                    <GardenWisemaintenanceStatusPopUp
                                                                        open={GardenMasterPopupShow}
                                                                        // GardenMasterFlag='GardenMaster'
                                                                        popupHeading="Garden Wise Maintainance Status"
                                                                        item={item}
                                                                        Flag='Update'
                                                                        M_AssetTypeID='1'
                                                                        handleIsPost={handleIsPost}
                                                                    />
                                                                </span>
                                                                <span>
                                                                    <DeletePopup
                                                                        open={DeletePopupShow}
                                                                    />
                                                                </span>

                                                                {/* const [DeletePopupShow, setDeletePopupShow] = useState() */}
                                                            </td>
                                                        </tr>
                                                    ) :
                                                        <td colSpan={15}>No data found</td>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {tableData && tableData.table && tableData.table.length > 0 &&
                                        <Pegination
                                            PerPageCount={PerPageCount}
                                            TotalCount={tableData.table[0].totalCount}
                                            setFrom={setFrom}
                                            setTo={setTo}
                                            setrowNo={setrowNo}
                                            CurrentPage={CurrentPage}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            {/* {
                GardenMasterPopupShow &&
                <GardenPopup
                    open={GardenMasterPopupShow}
                />

            } */}

            {
                showImagePopup ?
                    <ViewURL
                        // Heading="Farmer Photo"
                        setshowImagePopup={setshowImagePopup}
                        ImagePopUpData={ImagePopUpData}

                    />
                    : ''


            }

        </div >
    )
}